import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography
} from '@mui/material';
import { PDFViewer, Document, Page, Text, View, StyleSheet, pdf, Image, Link } from '@react-pdf/renderer';
import farmpactLogo from '../../../images/farmpact-logo.jpg';
import $data from '../../../services/$data';
import moment from 'moment';
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 20,
  },
  section: {

    padding: 10,
    // flexGrow: 1,
  },
});

const ApplicabilityReport = ({ open, data, photos, kml, onClose }) => {

  const [loading, setLoading] = useState(false);

  const getBlob = async () => {
    setLoading(true);
    try {
      let blob = await pdf(renderPdf()).toBlob();
      let file = new File([blob], 'applicability-report.pdf', { type: 'application/pdf' });
      await $data.uploadReport(file, data.id, 'applicability_report');
      onClose(true)

    } catch (error) {
      console.error('Error generating PDF blob:', error);
    } finally {
      setLoading(false);
    }
  }

  const renderPhotos = () => {

  }

  const renderPdf = () => {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={{ ...styles.section, alignItems: 'center' }}>
            <Image src={farmpactLogo} style={{ width: '200px' }} />
            <Text style={{ marginTop: '20px' }}>Applicability Report</Text>
          </View>
          <View style={{ padding: 20, paddingBottom: '10px' }}>
            <Text style={{ fontSize: '14px' }}>Farm: <Text style={{ fontWeight: 'bold', color: '#486c53' }}>{data.project.name}</Text></Text>
          </View>
          <View style={{ borderBottom: '1px dashed gray', marginHorizontal: 20 }}>
          </View>
          <View style={{ padding: 20, paddingBottom: '10px', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <View>
              <Text style={{ marginBottom: '10px', fontSize: '14px' }}>Parcel: <Text style={{ fontWeight: 'bold', color: '#486c53' }}>{data.name}</Text></Text>
              <Text style={{ marginBottom: '10px', fontSize: '14px' }}>Area: <Text style={{ fontWeight: 'bold', color: '#486c53' }}>{data.area} ha</Text></Text>
              <Text style={{ marginBottom: '10px', fontSize: '14px' }}>Crop: <Text style={{ fontWeight: 'bold', color: '#486c53' }}>{data.crop || 'Olives'}</Text></Text>

            </View>

            <Link src={kml.doc} style={{ marginLeft: '20px' }}>
              <View style={{ width: '120px', height: '50px', border: '1px solid #486c53', backgroundColor: '#486c53', borderRadius: '4px', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ fontSize: '14px', color: '#fff' }}>Download KML</Text>
              </View>
            </Link>
          </View>
          <View style={{ borderBottom: '1px dashed gray', marginHorizontal: 20 }}>
          </View>

          <View style={{ padding: '20px', paddingBottom: '5px' }}>

            <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '5px' }}>
              <Text style={{ fontSize: '14px' }}>Condtion 1:</Text>
              <Text style={{ fontWeight: 'bold', color: '#486c53', marginLeft: '10px', fontSize: '14px' }}>Condition met</Text>
              <Image src="https://upload.wikimedia.org/wikipedia/commons/c/c6/Sign-check-icon.png" style={{ width: '15px', marginLeft: '10px' }} />
            </View>
            <Text style={{ color: '#486c53', fontSize: '12px', lineHeight: '20px' }}>An area is eligible for the project if it was NOT any of the following Corine Land Cover classes within the 20 years prior to joining the FARMPACT program: Forest, Transitional woodland/shrub, Wetlands and Water bodies</Text>
            <Text style={{ fontSize: '10px', marginTop: '5px', fontStyle: 'italic' }}>This parcel's land cover history was checked using the {' '}
              <Link src="https://land.copernicus.eu/en/products/corine-land-cover">
                CORINE Land Cover © European Union, Copernicus Land Monitoring Service, European Environment Agency (EEA)
              </Link>
            </Text>

          </View>

          <View style={{ padding: '20px', paddingBottom: '5px' }}>
            <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '5px' }}>
              <Text style={{ fontSize: '14px' }}>Condtion 2:</Text>
              <Text style={{ fontWeight: 'bold', color: '#486c53', marginLeft: '10px', fontSize: '14px' }}>Condition met</Text>
              <Image src="https://upload.wikimedia.org/wikipedia/commons/c/c6/Sign-check-icon.png" style={{ width: '15px', marginLeft: '10px' }} />
            </View>
            <Text style={{ color: '#486c53', fontSize: '12px', marginBottom: '10px', lineHeight: '20px' }}>Project must involve exclusively olives or almonds</Text>
            <View break style={{ flexDirection: 'row', marginTop: '5px', flexWrap: 'wrap' }}>
              {photos.length > 0 ? photos.map((photo, index) => (
                <View key={index}>
                  <Link src={photo.image} style={{ marginRight: '10px', position: 'relative' }}>
                    <Image src={photo.image} style={{ width: '100px' }} />
                    <View style={{ backgroundColor: 'orange', padding: '5px', borderRadius: '5px', position: 'absolute', top: '5px', left: '5px' }}>
                      <Text style={{ fontSize: '10px', color: 'white', fontWeight: 'bold', }}>#applicability</Text>
                    </View>
                  </Link>
                  <Link src={`https://www.google.com/maps/search/?api=1&query=${photo.latitude},${photo.longitude}`}>
                    <Text style={{ fontSize: '10px', marginTop: '2px' }}>{photo.latitude.toFixed(6)}, {photo.longitude.toFixed(6)}</Text>
                  </Link>
                  <Text style={{ fontSize: '10px', marginTop: '2px', marginBottom: '10px'}}>{moment(photo.date_time).format('DD MMM, YYYY')}</Text>
                </View>
              )) : null}


            </View>
          </View>

        </Page>
      </Document>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={(evt, reason) => {
        if (!loading) {
          onClose()
        }
      }}
      maxWidth="md"
      fullScreen
    >
      <DialogTitle>
        Applicability Report
        <IconButton
          aria-label="close"
          onClick={(evt) => {
            if (!loading) {
              onClose()
            }
          }}
          color="secondary"
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <PDFViewer showToolbar={false} style={{ border: 'none', boxShadow: '1px 1px 5px 5px rgba(0,0,0,0.2)' }} width="100%" height="780px">
          {renderPdf()}
        </PDFViewer>
      </DialogContent>

      <DialogActions>
        <Button disabled={loading} onClick={onClose}>
          Cancel
        </Button>
        <Button disabled={loading} onClick={getBlob} variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApplicabilityReport;